import React from "react";
import "./Logos.css";
import IBM from "./images/logos/ibm.png";
import Horner from "./images/logos/horner.png";

const LogosPatrons = () => {
  const patrons = [
    {
      name: "IBM",
      logo: IBM,
      url: "https://www.ibm.com/us-en",
    },
    {
      name: "Horner Automation",
      logo: Horner,
      url: "https://hornerautomation.eu/",
    },
  ];

  return (
    <div className="logo-container">
      {patrons.map(function (data) {
        return (
          <a href={data.url}>
            <img className="logo-image" src={data.logo} />
          </a>
        );
      })}
    </div>
  );
};

export default LogosPatrons;
